(() => {
  const SELECTOR = '[data-cdg-header]';

  function initHeader(header) {
    if (header.dataset.cdgInitialized === 'true') return;
    header.dataset.cdgInitialized = 'true';

    const body = document.body;
    const drawer = header.querySelector('[data-cdg-drawer]');
    const openButton = header.querySelector('[data-cdg-drawer-open]');
    const closeButtons = header.querySelectorAll('[data-cdg-drawer-close]');
    const searchButton = header.querySelector('[data-cdg-search-toggle]');
    const mobileSearch = header.querySelector('[data-cdg-mobile-search]');
    const announcement = header.querySelector('[data-cdg-announcement]');
    const announcementClose = header.querySelector('[data-cdg-announcement-close]');
    let returnFocus = null;

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function setDrawer(open) {
      if (!drawer || !openButton) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      openButton.setAttribute('aria-expanded', String(open));
      body.classList.toggle('cdg-lock-scroll', open);
      if (open) {
        returnFocus = document.activeElement;
        drawer.querySelector(focusableSelector)?.focus();
      } else {
        (returnFocus || openButton).focus();
      }
    }

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setDrawer(false);
        return;
      }
      if (event.key !== 'Tab') return;
      const items = [...drawer.querySelectorAll(focusableSelector)].filter((item) => item.offsetParent !== null);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });

    searchButton?.addEventListener('click', () => {
      const open = mobileSearch.hidden;
      mobileSearch.hidden = !open;
      searchButton.setAttribute('aria-expanded', String(open));
      if (open) mobileSearch.querySelector('input')?.focus();
    });

    const announcementKey = `cdg-announcement-${header.dataset.sectionId}`;
    if (sessionStorage.getItem(announcementKey) === 'closed' && announcement) announcement.hidden = true;
    announcementClose?.addEventListener('click', () => {
      announcement.hidden = true;
      sessionStorage.setItem(announcementKey, 'closed');
    });

    if (header.dataset.sticky === 'true') {
      const updateSticky = () => header.classList.toggle('is-sticky', window.scrollY > 80);
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
    }
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initHeader);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
